export class CardAttendance {
    Class: string;
    DaysPresent: number;
    HoursPresent: number;
    IsTotalRow: boolean;
    Marked: string;
    Meets: string;
    TodaysAbsences: number;
    TodaysTardies: number;
    TotalAbsences: number;
    TotalDays: number;
    TotalHours: number;
    TotalTardies: number;
    DailyAttendanceStatus: string;
}